/**
 * Предпросмотр локального файла.
 *
 * URL.createObjectURL существует только в браузере: в нативной сборке
 * превью строится из пути к файлу. Экраны об этой разнице знать не должны.
 *
 * Отдельно важно освобождение: без revoke каждое перевыбранное фото
 * оставляет blob в памяти до перезагрузки страницы, а в мастере приёмки
 * их шесть.
 */
export function objectUrl(file) {
  if (!file) return null
  return URL.createObjectURL(file)
}

export function revokeObjectUrl(url) {
  if (url && url.startsWith('blob:')) URL.revokeObjectURL(url)
}
